import {InvoicepaymentService} from '../invoicepayment.service';
import {CashaccountResourceService} from './resource/cashaccount-resource.service';
import {DepotResourceService} from './resource/depot-resource.service';
import {LokijsService} from './lokijs.service';
import {Injectable} from '@angular/core';
import {OperatorResourceService} from './resource/operator-resource.service';
import {ProductResourceService} from './resource/product-resource.service';
import {DocumentResourceService} from './resource/document-resource.service';
import {CustomerResourceService} from './resource/customer-resource.service';
import {SiteResourceService} from './resource/site-resource.service';
import {PlantHireResourceService} from './resource/plant-hire-resource.service';
import {JobListService} from './resource/job-list.service';
import {UpdateTimeStampService} from './update-time-stamp.service';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {MobileConfigResourceService} from './resource/mobile-config-resource.service';
import {UpdateDatabaseService} from './update-database.service';
import {Subject} from 'rxjs';
import {DocumentModel} from '../../models/document.model';
import {LiveContractResourceService} from './resource/live-contract-resource.service';
import {ActionResourceService} from './resource/action-resource.service';
import {ActionDateQueryModel} from '../../models/action-date-query.model';
import {ConfigurationService} from '../configuration.service';
import {RemoveTransportLinesFromReturnService} from '../remove-transport-lines-from-return.service';
import {StateManagerService} from '../state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {OrderHealthCareResourceService} from './resource/order-health-care-resource.service';
import {DocumentTypes} from '../../definitions/document-types';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {TestConnectionService} from '../test-connection.service';
import {QueueStatus} from '../../definitions/queue-status';
import {ConfigurationModel} from '../../models/configuration.model';
import {GenerateDocFromOrderService} from '../generate-doc-from-order.service';

@Injectable({
    providedIn: 'root'
})
export class RefreshdatabaseService {

    message = 'Waiting Connection';
    public loadingMsg = new Subject<string>();

    constructor(private operatorResource: OperatorResourceService,
                private depotResource: DepotResourceService,
                private productResource: ProductResourceService,
                private documentResource: DocumentResourceService,
                private customerResource: CustomerResourceService,
                private plantHireResource: PlantHireResourceService,
                private siteResource: SiteResourceService,
                private jobListResource: JobListService,
                private loki: LokijsService,
                private updateTimeStamp: UpdateTimeStampService,
                private mobileConfigResource: MobileConfigResourceService,
                private customerRes: CustomerResourceService,
                private updateDB: UpdateDatabaseService,
                private cashAccountResource: CashaccountResourceService,
                private liveContractsResource: LiveContractResourceService,
                private actionsResource: ActionResourceService,
                private configurationService: ConfigurationService,
                private removeTransportLines: RemoveTransportLinesFromReturnService,
                private invoicePaymentService: InvoicepaymentService,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private orderHealthCareResource: OrderHealthCareResourceService,
                private documentTypes: DocumentTypes,
                private testConnectionService: TestConnectionService,
                private queuedStatusDefinition: QueueStatus,
                private generateDocFromOrder: GenerateDocFromOrderService) {
    }
    
    async refresh() {

        this.loadingMsg.next(this.message);
        const config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION) as ConfigurationModel;
    
        try {
            await this.updateDB.updateDatabase();
            await this.loki.databaseHasBeenLoaded();
            await this.refreshMobileConfig();
            const mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION) as MobileConfigurationModel;

           
            await this.refreshOperatorResource();
            await this.refreshDepotResource();
            await this.refreshDocumentResource();
            await this.refreshCashAccountsResource();
            
            if( mobileConfig.mobilehireSelfAssignDocuments === 1){
                await this.refreshQueuedDocumentsAll();
            }else{
                await this.refreshQueuedDocuments();
            }
            
            
            await this.refreshContactsResource();
            if (config) {
                await this.refreshCustomerResource();
                await this.refreshSiteResource();
                await this.refreshProductResource();
                await this.refreshPlantHireResource();
                await this.refreshJobListResource();
                await this.refreshJobList();
                await this.refreshLiveContractsResource();
                await this.refreshActionResource();
                await this.refreshActionTypeAndPriorityResource();
            }
        } catch (e) {
            console.log(e);
        }
        console.log(this.loki.db);
    }

    async refreshMobileConfig() {
        try {
            this.message = 'Loading Mobile Config...';
            this.loadingMsg.next(this.message);
            const tempData: any = await this.mobileConfigResource.getMobileConfig();
            await this.stateManager.clear('mobileconfiguration');
            const data = [tempData];
            await this.stateManager.bulkUpsert('mobileconfiguration', '$loki', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading System Config...';
            this.loadingMsg.next(this.message);
            const tempData: any = await this.mobileConfigResource.getSystemConfig();
            const data = tempData;
            await this.stateManager.bulkUpsert('systemconfiguration', 'num', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshCustomerResource() {
        try {
            this.message = 'Loading Customers...';
            this.loadingMsg.next(this.message);
            const data: any = await this.customerResource.getCustomers();
            await this.stateManager.bulkUpsert('customer', 'id', data);
            this.updateTimeStamp.updateTimeStamp('custDateTime');
        } catch (e) {
            console.log(e);
        }
    }

    async refreshContactsResource() {
        try {
            this.message = 'Loading Contacts...';
            this.loadingMsg.next(this.message);
            const data: any = await this.customerResource.getContacts();
            for (const contact of data) {
                if (!contact.name) {
                    contact.name = '';
                }
            }
            await this.stateManager.bulkUpsert('contact', 'id', data);
            this.updateTimeStamp.updateTimeStamp('contactDateTime');
        } catch (e) {
            console.log(e);
        }
    }

    async refreshOperatorResource() {
        try {
            this.message = 'Loading Operators...';
            this.loadingMsg.next(this.message);
            const data: any = await this.operatorResource.getOperators();
            await this.stateManager.bulkUpsert(this.collectionNames.OPERATOR, 'cod', data);
        } catch (e) {
            console.log(e);
        }
        try {
            this.message = 'Loading Operators...';
            this.loadingMsg.next(this.message);
            const data: any = await this.operatorResource.getOperatorsAndAPIKeys();
            await this.stateManager.bulkUpsert(this.collectionNames.OPERATORANDAPIKEY, 'cod', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Printers...';
            this.loadingMsg.next(this.message);
            const data: any = await this.operatorResource.getPrinters();
            await this.stateManager.clear('printlist');
            await this.stateManager.bulkUpsert('printlist', '$loki', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Engineers...';
            this.loadingMsg.next(this.message);
            const data: any = await this.operatorResource.getEngineers();
            await this.stateManager.bulkUpsert('engineer', 'id', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshDepotResource() {
        try {
            this.message = 'Loading Depots...';
            this.loadingMsg.next(this.message);
            const data: any = await this.depotResource.getDepots();
            await this.stateManager.bulkUpsert('depot', 'cod', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshSiteResource() {
        try {
            this.message = 'Loading Sites...';
            this.loadingMsg.next(this.message);
            const data: any = await this.siteResource.getSites();
            await this.stateManager.bulkUpsert('site', 'id', data);
            this.updateTimeStamp.updateTimeStamp('siteDateTime');
        } catch (e) {
            console.log(e);
        }
    }

    async refreshDocumentResource() {
        try {
            this.message = 'Loading Doc Types...';
            this.loadingMsg.next(this.message);
            const data: any = await this.documentResource.getDocTypes();
            await this.stateManager.bulkUpsert('documentRequestType', 'id', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshProductResource() {
        try {
            this.message = 'Loading Product Dept...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getDepartments();
            await this.stateManager.bulkUpsert('dept', 'nsuk', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Product Dept Group...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getGroupList();
            await this.stateManager.bulkUpsert('deptGroup', 'nsuk', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Products...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getProduct();
            await this.stateManager.bulkUpsert('producttype', 'id', data);
            this.updateTimeStamp.updateTimeStamp('productDateTime');
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Spares...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getSparesForWs();
            await this.stateManager.bulkUpsert(this.collectionNames.SPARESUSEDINWS, 'id', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading S Access...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getSaccess();
            await this.stateManager.bulkUpsert('saccess', 'id', data);
            this.updateTimeStamp.updateTimeStamp('saccessDateTime');
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading PT Serials...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getPTSerial();
            if (data) {
                await this.stateManager.bulkUpsert('ptserial', 'id', data);
                this.updateTimeStamp.updateTimeStamp('ptSerialDateTime');
            }
        } catch (e) {
            this.message = 'Error loading PT Serials...';
            this.loadingMsg.next(this.message);
        }

        try {
            this.message = 'Loading Price Lists...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getPriceList();
            await this.stateManager.bulkUpsert('pricelist', 'nsuk', data);
        } catch (e) {
            this.message = 'Error loading Price Lists...';
            this.loadingMsg.next(this.message);
        }

        try {
            this.message = 'Loading Price Details...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getPriceListDetails();
            if (data) {
                await this.stateManager.bulkUpsert('pricelistdetails', 'id', data);
                this.updateTimeStamp.updateTimeStamp('priceListDetailsDateTime');
            }
        } catch (e) {
            this.message = 'Error loading Price Details...';
            this.loadingMsg.next(this.message);
        }

        try {
            this.message = 'Loading Policy...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getPolicy();
            await this.stateManager.bulkUpsert('policy', '$loki', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Barcodes...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getProductWithBarcodeForStockTake();
            await this.stateManager.bulkUpsert(this.collectionNames.PRODUCTBARCODESTOCKTAKE, 'barcode', data);
        } catch (e) {
            console.log(e);
        }

        this.refreshBinLocations();
    }

    async refreshBinLocations(){
       try {
            this.message = 'Loading Bin Locations...';
            this.loadingMsg.next(this.message);
            const data: any = await this.productResource.getAllBinLocations();
            if( data != null){
                this.stateManager.clear(this.collectionNames.BINLOCATIONS); 
            }
            await this.stateManager.bulkUpsert(this.collectionNames.BINLOCATIONS, 'nsuk', data);
        } catch (e) {
            console.log(e);
        } 
    }

    async refreshPlantHireResource() {
        try {
            this.message = 'Loading Hire Dept...';
            this.loadingMsg.next(this.message);
            const data: any = await this.plantHireResource.getHireDeptList();
            await this.stateManager.bulkUpsert('hireDept', 'nsuk', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Hire Dept Group...';
            this.loadingMsg.next(this.message);
            const data: any = await this.plantHireResource.getHireGroupList();
            await this.stateManager.bulkUpsert('hireDeptGroup', 'nsuk', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Equipment...';
            this.loadingMsg.next(this.message);
            const data: any = await this.plantHireResource.getEquipment();
            const dataCopy = data.filter(equip => {
                return (equip.typ === 'S' && equip.reg) || equip.typ !== 'S';
            });
            await this.stateManager.bulkUpsert('equipment', 'id', dataCopy);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Plant Status...';
            this.loadingMsg.next(this.message);
            const data: any = await this.plantHireResource.getPlantStatus();
            await this.stateManager.bulkUpsert('plantstatuslist', 'nsuk', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading H Access...';
            this.loadingMsg.next(this.message);
            const data: any = await this.plantHireResource.getHaccess();
            await this.stateManager.bulkUpsert('haccess', 'id', data);
            this.updateTimeStamp.updateTimeStamp('haccessDateTime');
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Hrates...';
            this.loadingMsg.next(this.message);
            const data: any = await this.plantHireResource.getHrates();
            await this.stateManager.bulkUpsert('hrates', 'id', data);
            this.updateTimeStamp.updateTimeStamp('haccessDateTime');
        } catch (e) {
            console.log(e);
        }

        await this.filterDistinctPdesc();
    }

    async refreshJobListResource() {
        try {
            this.message = 'Loading Jobs...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getJobStatusList();
            await this.stateManager.bulkUpsert('jobstatuslist', 'id', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Job Types...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getJobTypeList();
            await this.stateManager.bulkUpsert('jobtype', 'id', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Meter type...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getMeterReadingTypes();
            await this.stateManager.bulkUpsert('metertype', 'id', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Job Certificates...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getJobCertificates();
            await this.stateManager.bulkUpsert('jobcertificatetext', 'id', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Job Template...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getJobTemplate();
            await this.stateManager.clear('jobtemplate');
            await this.stateManager.bulkUpsert('jobtemplate', '$loki', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Tasks...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getTasksList();
            await this.stateManager.bulkUpsert('tasks', 'nsuk', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Mandatory Meters...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getMeterMandatoryReading();
            await this.stateManager.bulkUpsert('mandatorymeters', 'id', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshJobList() {
        try {
            this.message = 'Loading Job List...';
            this.loadingMsg.next(this.message);
            const data: any = await this.jobListResource.getJobList();
            const documents: any = await this.stateManager.getCollection('document');
            if (documents.length > 0 && data.length > 0) {
                // will check if the document is already stored in the document collection to avoid duplication
                for (const doc of documents) {
                    for (let j = 0; j < data.length; j++) {

                        if (doc.serviceJob) {
                            if (doc.serviceJob.jobNumber === data[j].jobNumber) {
                                await data.splice(j, 1);
                            }
                        }
                    }
                }
            }
            if (data) {
                for (const entry of data) {
                    entry.isNewDoc = true;
                }
            }
            await this.stateManager.clear('servicejob');
            await this.stateManager.bulkUpsert('servicejob', 'id', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshQueuedDocuments() {
        this.message = 'Loading Queued Docs...';
        this.loadingMsg.next(this.message);
        const mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION) as MobileConfigurationModel;
        const documentsSavedOnDevice = this.stateManager.getCollection(this.collectionNames.DOCUMENT) as DocumentModel[];
        let data1 = [];
        let data2 = [];

        try {
            data1 = await this.documentResource.getQueuedDocs() as DocumentModel[];
            if (mobileConfig && mobileConfig.mobilehireHealthCareInUse === 1) {
                data2 = await this.orderHealthCareResource.getQueuedOrdersForHealtCare() as DocumentModel[];
            }
            const data = [...data1, ...data2] as DocumentModel[];
            await this.stateManager.clear(this.collectionNames.QUEUEDDOCUMENTS);
            console.log(data);
            const dataCopy = [];
            if (data as DocumentModel[]) {
                const equipmentList = this.stateManager.getCollection(this.collectionNames.EQUIPMENT);
                for (const entryTemp of data) {
                    const entry = JSON.parse(JSON.stringify(entryTemp));
                    // entry.isNewDoc = true;
                    entry.queueStatus = this.queuedStatusDefinition.UNSYNCED;
                    if (entry.documentType === 7) {
                        entry.cloneOfDetailLines = JSON.parse(JSON.stringify(entry.detailLines));
                    } else if (entry.documentType === 2) {
                        entry.cloneOfDetailLines = entry.detailLines;
                    }
                    for (const detail of entry.detailLines) {
                        const tempEquip = equipmentList.find(line => {
                            // tslint:disable-next-line:triple-equals
                            return (line.pdesc == detail.pdesc && line.reg == detail.reg);
                        });
                        console.log(tempEquip);
                        if (tempEquip) {
                            detail.barcode = tempEquip.barcode;
                        }
                        if (detail.pdesc) {
                            detail.overrideDescriptionNote = detail.description;
                            if (tempEquip) {
                                detail.typ = tempEquip.typ;
                            }
                        }
                        //if (detail.plu) {
                        //    detail.comment = detail.description;
                       // }
                        if (entry.documentType === 7 && mobileConfig && ( mobileConfig.mobilehireUnfulfilledCollection === 1 || mobileConfig.mobilehireHealthCareInUse ===1 ) ) {
                            detail.requiredQty = detail.qty;
                            detail.qty = 0;
                        }
                    }
                    if (entry.documentType !== this.documentTypes.ORDER) {
                        entry.originalDocumentType = entry.documentType;
                        entry.documentType = this.documentTypes.SIGNDOCUMENT;
                    } else {
                        // const contractFromOrder = this.generateDocFromOrder.generateDoc(entry);
                        // this.stateManager.upsert(this.collectionNames.DOCUMENT, )
                        // dataCopy.push(contractFromOrder);
                    }
                    // TODO: Check if the document is present on the mobile
                    dataCopy.push(entry);
                }
            }
            console.log(dataCopy);
            await this.stateManager.bulkUpsert(this.collectionNames.QUEUEDDOCUMENTS, '$loki', dataCopy);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshQueuedDocumentsAll() {
        this.message = 'Loading Queued Docs...';
        this.loadingMsg.next(this.message);
        const mobileConfig = this.stateManager.getCollection(this.collectionNames.MOBILECONFIGURATION) as MobileConfigurationModel;
        const documentsSavedOnDevice = this.stateManager.getCollection(this.collectionNames.DOCUMENT) as DocumentModel[];
        let data1 = [];
        let data2 = [];

        try {
            data1 = await this.documentResource.getUnassignedAndForOperatorQueuedDocs() as DocumentModel[];
            const data = [...data1 ] as DocumentModel[];
            await this.stateManager.clear(this.collectionNames.QUEUEDDOCUMENTS);
            console.log(data);
            const dataCopy = [];
            if (data as DocumentModel[]) {
                const equipmentList = this.stateManager.getCollection(this.collectionNames.EQUIPMENT);
                for (const entryTemp of data) {
                    const entry = JSON.parse(JSON.stringify(entryTemp));
                    // entry.isNewDoc = true;
                    entry.queueStatus = this.queuedStatusDefinition.UNSYNCED;
                    if (entry.documentType === 7) {
                        entry.cloneOfDetailLines = JSON.parse(JSON.stringify(entry.detailLines));
                    } else if (entry.documentType === 2) {
                        entry.cloneOfDetailLines = entry.detailLines;
                    }
                    for (const detail of entry.detailLines) {
                        const tempEquip = equipmentList.find(line => {
                            // tslint:disable-next-line:triple-equals
                            return (line.pdesc == detail.pdesc && line.reg == detail.reg);
                        });
                        console.log(tempEquip);
                        if (tempEquip) {
                            detail.barcode = tempEquip.barcode;
                        }
                        if (detail.pdesc) {
                            detail.overrideDescriptionNote = detail.description;
                            if (tempEquip) {
                                detail.typ = tempEquip.typ;
                            }
                        }
                        //if (detail.plu) {
                        //    detail.comment = detail.description;
                        //}
                        if (entry.documentType === 7 && mobileConfig && ( mobileConfig.mobilehireUnfulfilledCollection === 1 || mobileConfig.mobilehireHealthCareInUse ===1 ) ) {
                            detail.requiredQty = detail.qty;
                            detail.qty = 0;
                        }
                    }
                    if (entry.documentType !== this.documentTypes.ORDER) {
                        entry.originalDocumentType = entry.documentType;
                        entry.documentType = this.documentTypes.SIGNDOCUMENT;
                    } else {
                        // const contractFromOrder = this.generateDocFromOrder.generateDoc(entry);
                        // this.stateManager.upsert(this.collectionNames.DOCUMENT, )
                        // dataCopy.push(contractFromOrder);
                    }
                    // TODO: Check if the document is present on the mobile
                    dataCopy.push(entry);
                }
            }
            console.log(dataCopy);
            await this.stateManager.bulkUpsert(this.collectionNames.QUEUEDDOCUMENTS, '$loki', dataCopy);
        } catch (e) {
            console.log(e);
        }
    }




    async filterDistinctPdesc() {
        let data: any;
        const distinct: DetaillineDTOModel[] = [];
        await this.plantHireResource.getEquipment().then(equip => {
            this.updateTimeStamp.updateTimeStamp('equipmentDateTime');
            data = equip;
            data.forEach((elem) => {
                if (distinct.indexOf(elem.pdesc) === -1) {
                    elem.reg = null;
                    distinct.push(elem);
                }
            });
        });
        await this.stateManager.bulkUpsert('equipmentdistinctpdesc', 'pdesc', distinct);
    }

    async fetchContracts(document) {
        try {
            this.message = 'Loading Contracts...';
            this.loadingMsg.next(this.message);
            const data: any = await this.customerRes.getContracts(document.customer.id);
            await this.stateManager.bulkUpsert('return', 'documentNumber', data);
        } catch (e) {
            console.log(e);
        }

    }

    async refreshCashAccountsResource() {
        try {
            this.message = 'Loading Cash Accounts...';
            this.loadingMsg.next(this.message);
            const data: any = await this.cashAccountResource.getCashAccounts();
            await this.stateManager.bulkUpsert('cashaccounts', 'cod', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Payment Methods...';
            this.loadingMsg.next(this.message);
            const data: any = await this.cashAccountResource.getPaymentMethods();
            await this.stateManager.bulkUpsert('paymentmethods', 'cod', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshLiveContractsResource() {
        try {
            const depots = await this.stateManager.getCollection('depot') as any;
            let data = [];
            for (const d of depots) {
                this.message = 'Loading Contracts...';
                this.loadingMsg.next(this.message);
                const fetch: any = await this.liveContractsResource.getLiveDetailLines(d.cod);
                data = [...fetch];
            }
            const plus = this.removeTransportLines.findTransportPlus();
            this.stateManager.clear('livedetaillines');
            data = data.filter(line => {
                return !plus.includes(line.plu);
            });
            const equipmentList = this.stateManager.getCollection(this.collectionNames.EQUIPMENT);
            for (const d of data) {
                d.requiredQty = d.qty;
                const tempEquip = equipmentList.find(equip => {
                    // tslint:disable-next-line:triple-equals for sake of simplicity
                    return d.pdesc === equip.pdesc && d.reg === equip.reg && d.plu == equip.plu;
                });
                // console.log(tempEquip);
                if (tempEquip) {
                    d.barcode = tempEquip.barcode;
                }
            }
            await this.stateManager.bulkUpsert('livedetaillines', '_id', data);
        } catch (e) {
            console.log(e);
        }
    }

    async refreshActionResource() {
        /*try {
            this.message = 'Loading Actions...';
            this.loadingMsg.next(this.message);
            const data: any = await this.actionsResource.getActions(this.genActionDateQuery());
            this.stateManager.clear('queuedaction');
            const currentActions: any = this.stateManager.getCollection('action');
            if (currentActions.length > 0 && data.length > 0) {
                // will check if the document is already stored in the document collection to avoid duplication
                for (const action of currentActions) {
                    for (let j = 0; j < data.length; j++) {
                        if (action.id === data[j].id) {
                            await data.splice(j, 1);
                        }
                    }
                }
            }
            await this.stateManager.bulkUpsert('queuedaction', 'id', data);
        } catch (e) {
            console.log(e);
        }*/
    }

    async refreshActionTypeAndPriorityResource() {
        try {
            this.message = 'Loading Action Types...';
            this.loadingMsg.next(this.message);
            const data: any = await this.actionsResource.getActionTypes();
            await this.stateManager.bulkUpsert('actiontype', 'id', data);
        } catch (e) {
            console.log(e);
        }

        try {
            this.message = 'Loading Action Priorities...';
            this.loadingMsg.next(this.message);
            const data: any = await this.actionsResource.getActionPriorities();
            await this.stateManager.bulkUpsert('actionpriority', 'id', data);
        } catch (e) {
            console.log(e);
        }
    }

    private genActionDateQuery(): ActionDateQueryModel {

        const config = this.stateManager.getCollection(this.collectionNames.CONFIGURATION);
        const toDate = new Date();
        const dateFrom = new Date(toDate.getTime() - (config.daysOfCompletedActions * 1000 * 60 * 60 * 24));

        const actionQueryModel = new ActionDateQueryModel();
        actionQueryModel.fromDate = dateFrom.toISOString();
        actionQueryModel.toDate = toDate.toISOString();
        actionQueryModel.operator = config.selectedOperator;
        return actionQueryModel;
    }
}
